import { request } from 'utilities/request'

export const fetchBalances = async (
  app,
  session,
  locationType,
  locationId,
  productVariantId,
  oldTicketItems,
) => {
  if (!productVariantId || productVariantId.length === 0) return []
  const input = { productVariantId, locationType, locationId }
  // if (locationId) input.locationId = locationId
  if (!locationId) return []

  const variables = { input }
  const query = `
    query($input: InventoryInput!) {
      inventoryPartBalances(input: $input) {
        productVariantId
        quantity
      }
    }
  `
  const [ok, data] = await request({ query, variables }, { session, app })
  if (!ok) return []

  const balances = data.inventoryPartBalances
  if (oldTicketItems) {
    balances.forEach((balance) => {
      const matched = oldTicketItems.find(
        (item) => item.productVariantId === balance.productVariantId,
      )
      if (matched) balance.quantity += matched.quantity
    })
  }

  return balances
}

export const fetchBalance = async (
  app,
  session,
  locationType,
  locationId,
  productVariantId,
  oldTicketItems,
) => {
  const variantIdList = [productVariantId]
  const balances = await fetchBalances(
    app,
    session,
    locationType,
    locationId,
    variantIdList,
    oldTicketItems,
  )
  return balances.length > 0 ? balances[0].quantity : 0
}
